import { DemoLight } from "../../buttons"
import hero from "../../images/technologies-hero.svg"

export default function TechHero() {
  return (
    <>
      <section className="px-5 2xl:px-0 md:grid grid-cols-2 gap-10 items-center xl:max-w-6xl xl:mx-auto py-10 lg:pt-48 lg:pb-20">
        <article>
          <h1 className="mb-1 leading-tight">
            Your one-stop shop for all of your technical needs.
          </h1>
          <p className="lg:text-2xl">
            The Be-Brokers has a wide variety of services that can fit your
            company's needs. We provide a full range of IT services to your
            business, including website design and development, cybersecurity
            services, VPS hosting and many more.
          </p>
          <div className="mt-8">
            <DemoLight />
          </div>
        </article>

        <article>
          <img
            src={hero}
            alt="Consistently Great Customer Service"
            title="Consistently Great Customer Service"
            className="block mx-auto"
          />
        </article>
      </section>
    </>
  )
}
